/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendSubscriptionTransactionInfoRequestOmitted
 */
export interface SendSubscriptionTransactionInfoRequestOmitted {
    /**
     * 
     * @type {string}
     * @memberof SendSubscriptionTransactionInfoRequestOmitted
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof SendSubscriptionTransactionInfoRequestOmitted
     */
    userPhoneNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof SendSubscriptionTransactionInfoRequestOmitted
     */
    userMlsId: string;
    /**
     * 
     * @type {string}
     * @memberof SendSubscriptionTransactionInfoRequestOmitted
     */
    officeName: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SendSubscriptionTransactionInfoRequestOmitted
     */
    acceptTermsOfService: boolean;
}

/**
 * Check if a given object implements the SendSubscriptionTransactionInfoRequestOmitted interface.
 */
export function instanceOfSendSubscriptionTransactionInfoRequestOmitted(value: object): value is SendSubscriptionTransactionInfoRequestOmitted {
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('userPhoneNumber' in value) || value['userPhoneNumber'] === undefined) return false;
    if (!('userMlsId' in value) || value['userMlsId'] === undefined) return false;
    if (!('officeName' in value) || value['officeName'] === undefined) return false;
    if (!('acceptTermsOfService' in value) || value['acceptTermsOfService'] === undefined) return false;
    return true;
}

export function SendSubscriptionTransactionInfoRequestOmittedFromJSON(json: any): SendSubscriptionTransactionInfoRequestOmitted {
    return SendSubscriptionTransactionInfoRequestOmittedFromJSONTyped(json, false);
}

export function SendSubscriptionTransactionInfoRequestOmittedFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendSubscriptionTransactionInfoRequestOmitted {
    if (json == null) {
        return json;
    }
    return {
        
        'userName': json['userName'],
        'userPhoneNumber': json['userPhoneNumber'],
        'userMlsId': json['userMlsId'],
        'officeName': json['officeName'],
        'acceptTermsOfService': json['acceptTermsOfService'],
    };
}

export function SendSubscriptionTransactionInfoRequestOmittedToJSON(json: any): SendSubscriptionTransactionInfoRequestOmitted {
    return SendSubscriptionTransactionInfoRequestOmittedToJSONTyped(json, false);
}

export function SendSubscriptionTransactionInfoRequestOmittedToJSONTyped(value?: SendSubscriptionTransactionInfoRequestOmitted | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userName': value['userName'],
        'userPhoneNumber': value['userPhoneNumber'],
        'userMlsId': value['userMlsId'],
        'officeName': value['officeName'],
        'acceptTermsOfService': value['acceptTermsOfService'],
    };
}

